export default __webpack_public_path__ + "static/media/onurbelgesi3.605d5b93.jpg";